import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";
import {IFile} from "./sliceFiles";

export interface ICameraLive {
  name: string
  sound?: boolean;
  image?: string;
  audio?: string;
  error?: string;
}

export interface ICameraStore {
  cameras: ICameraLive[]
}

export interface ICameraPayload {
  name: string,
  message: string
}

export interface ICameraPayloadSound {
  name: string,
  sound: boolean
}




export const initialState = {
  cameras: Array<ICameraLive>
};


const slice = createSlice({
  name: 'websocketCamera',
  initialState,
  reducers: {
    clear: (state: IRootState, action: PayloadAction<ICameraPayload>) => {
      state.cameras.forEach((camera: ICameraLive) => {
        if (camera.name == action.payload.name) {
          camera.image = "";
          camera.audio = "";
          camera.error = "";
        }
      })
    },

    init: (state: IRootState, action: PayloadAction<ICameraLive[]>) => {
      state.cameras = action.payload;
    },

    setImage: (state: IRootState, action: PayloadAction<ICameraPayload>) => {
      state.cameras.forEach((camera: ICameraLive) => {
        if (camera.name == action.payload.name) {
          camera.image = action.payload.message
        }
      })
    },

    setAudio: (state: IRootState, action: PayloadAction<ICameraPayload>) => {
      state.cameras.forEach((camera: ICameraLive) => {
        if (camera.name == action.payload.name) {
          camera.audio = action.payload.message
        }
      })
    },

    setError: (state: IRootState, action: PayloadAction<ICameraPayload>) => {
      state.cameras.forEach((camera: ICameraLive) => {
        if (camera.name == action.payload.name) {
          camera.error = action.payload.message
        }
      })
    },

    setSound: (state: IRootState, action: PayloadAction<ICameraPayloadSound>) => {
      state.cameras.forEach((camera: ICameraLive) => {
        if (camera.name == action.payload.name) {
          camera.sound = action.payload.sound
        }
      })
    },

  },
});

const { actions, reducer } = slice;

export { actions, reducer };
